import { render } from "./Famous.vue?vue&type=template&id=a637a24c"
import script from "./Famous.vue?vue&type=script&lang=js"
export * from "./Famous.vue?vue&type=script&lang=js"

import "./Famous.vue?vue&type=style&index=0&id=a637a24c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__